import { sortBy } from "lodash";

import { WhatsNextFinderFiltersFormTypes, WhatsNextOrderBy } from "../components/whats-next-finder";
import { getSearchParams, getUpdatedSearchParamsUrl } from "./search-params";

export function areFormFiltersEmpty(filters: Partial<WhatsNextFinderFiltersFormTypes>) {
  const { search, category } = filters;
  return !search && !category;
}

/**
 * @param whatsNextItems
 * @param appliedFilters
 * @returns The list of whatsNextItems matching filters
 */
export function filterWhatsNext(
  whatsNextItems: Queries.WhatsNextDataFragment[],
  appliedFilters: WhatsNextFinderFiltersFormTypes
) {
  const { search, orderBy, category } = appliedFilters;

  const filteredWhatsNext: Queries.WhatsNextDataFragment[] = whatsNextItems.filter((item) => {
    if (search && !item.title?.match(new RegExp(search, "gi"))) return false;
    if (category && !item.categories?.find((item) => item && item.label === category)) return false;
    return true;
  });

  const orderedWhatsNext = orderWhatsNextByDate(filteredWhatsNext, orderBy);

  return orderedWhatsNext;
}

export function getDefaultWhatsNextFinderFilters() {
  const defaultFiltersValues: WhatsNextFinderFiltersFormTypes = {
    search: "",
    orderBy: WhatsNextOrderBy.MORE_RECENT,
    category: "",
  };
  return defaultFiltersValues;
}

export function getFiltersFromSearchParams(
  searchParamKey: string
): null | Partial<WhatsNextFinderFiltersFormTypes> {
  const searchParams = getSearchParams();
  const searchParamFiltersAsString = searchParams?.get(searchParamKey || "filter");
  if (!searchParamFiltersAsString) return null;
  return JSON.parse(searchParamFiltersAsString);
}

export function setFiltersInSearchParams(
  _filter: null | Partial<WhatsNextFinderFiltersFormTypes>,
  searchParamKey: string
) {
  const filter = { ..._filter };

  if (!filter.search) delete filter.search;
  if (typeof window !== "undefined") {
    const path = getUpdatedSearchParamsUrl({
      [searchParamKey || "filter"]:
        filter && Object.keys(filter).length ? JSON.stringify(filter) : null,
    });
    window.history.pushState({ path }, "", path);
  }
}

function orderWhatsNextByDate(arr: Queries.WhatsNextDataFragment[], orderBy: string) {
  switch (orderBy) {
    case WhatsNextOrderBy.MORE_RECENT:
      return sortBy(arr, (item) => item.date).reverse();
    case WhatsNextOrderBy.LESS_RECENT:
      return sortBy(arr, (item) => item.date);
    default:
      return arr;
  }
}
